import { db, storage } from './firebase';
import { firestoreKeys } from '../utils/constants';

export default function useUserService() {
  const createUser = (userId, data) => db.collection(firestoreKeys.USERS).doc(userId).set(data);

  const getUserById = (userId) => db.collection(firestoreKeys.USERS).doc(userId).get();

  const updateUser = (userId, data) => db.collection(firestoreKeys.USERS).doc(userId).update(data);

  const uploadProfilePicture = (userId, image) => {
    const ref = storage.ref(`${firestoreKeys.USERS}/${userId}/${image.name}`);
    return ref.put(image).then(() => ref.getDownloadURL());
  };

  return { createUser, getUserById, updateUser, uploadProfilePicture };
}
